/**
 * Whether the MCP card offers "Contact us" instead of opening the page.
 *
 * Not `!mcpEnabled` alone: turning `mcp_enabled` off only stops new
 * connections, and the ones already made keep working. Interlude leaves the
 * list and revoke endpoints ungated for that reason, and the page is the only
 * place a customer can cut those connections off, so an organization that
 * still has any is let through.
 *
 * A list that failed to load is not a list with nothing in it: such an
 * organization is let through too, and the page reports the failure with a
 * retry instead of the card sending them to sales.
 */
export const shouldShowMcpContactUs = ({
  mcpEnabled,
  hasMcpConnections,
  isMcpConnectionListError,
}: {
  mcpEnabled: boolean;
  hasMcpConnections: boolean;
  isMcpConnectionListError: boolean;
}): boolean => !mcpEnabled && !hasMcpConnections && !isMcpConnectionListError;
